import { render, staticRenderFns } from "./GovernateEdit.vue?vue&type=template&id=eea64b5e&scoped=true&"
import script from "./GovernateEdit.vue?vue&type=script&lang=js&"
export * from "./GovernateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea64b5e",
  null
  
)

export default component.exports